import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "submit-apply-bd--wrap" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 我已阅读并同意 ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("提交报名")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Input = _resolveComponent("Input")!
  const _component_FormItem = _resolveComponent("FormItem")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Radio = _resolveComponent("Radio")!
  const _component_RadioGroup = _resolveComponent("RadioGroup")!
  const _component_OtherInfo = _resolveComponent("OtherInfo")!
  const _component_StudentInfo = _resolveComponent("StudentInfo")!
  const _component_JobInfo = _resolveComponent("JobInfo")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Popover = _resolveComponent("Popover")!
  const _component_Form = _resolveComponent("Form")!
  const _component_LoginDialog = _resolveComponent("LoginDialog")!
  const _component_RaceAgreement = _resolveComponent("RaceAgreement")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_RaceRule = _resolveComponent("RaceRule")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Form, {
      "label-position": "left",
      model: _ctx.formValue,
      rules: _ctx.rules,
      ref: "userInfo",
      "label-width": "72px",
      class: "submit-apply-bd--form",
      "hide-required-asterisk": true
    }, {
      default: _withCtx(() => [
        _createVNode(_component_FormItem, {
          label: "姓名",
          prop: "PlatName"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Input, {
              maxlength: "30",
              type: "text",
              modelValue: _ctx.formValue.PlatName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formValue.PlatName) = $event)),
              autocomplete: "off",
              clearable: true,
              placeholder: "请输入真实姓名"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_FormItem, {
          label: "身份证",
          prop: "IdNo"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Input, {
              type: "text",
              modelValue: _ctx.formValue.IdNo,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formValue.IdNo) = $event)),
              autocomplete: "off",
              clearable: true,
              placeholder: "请输入身份证号",
              "show-password": ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_FormItem, {
          label: "手机号",
          prop: "Mobile"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Input, {
              type: "text",
              modelValue: _ctx.formValue.Mobile,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formValue.Mobile) = $event)),
              autocomplete: "off",
              clearable: true,
              placeholder: "请输入手机号"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_FormItem, {
          label: "验证码",
          prop: "Token"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Input, {
              type: "text",
              modelValue: _ctx.formValue.Token,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formValue.Token) = $event)),
              autocomplete: "off",
              maxlength: "6",
              "show-word-limit": "",
              clearable: true,
              placeholder: "请输入验证码"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_Button, {
              id: "TencentCaptcha",
              "data-appid": "2054996702",
              "data-cbfn": "sscodeCallback",
              underline: false,
              disabled: _ctx.getDisabled,
              class: "yzm-button"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(typeof _ctx.sendCodeText === 'number' ? `重新获取(${_ctx.sendCodeText})s` : _ctx.sendCodeText), 1)
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_FormItem, {
          label: "邮箱",
          prop: "Email"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Input, {
              maxlength: "30",
              type: "text",
              modelValue: _ctx.formValue.Email,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formValue.Email) = $event)),
              autocomplete: "off",
              clearable: true,
              placeholder: "请输入邮箱"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_FormItem, {
          label: "参赛身份",
          prop: "Capacity",
          class: "submit-apply-bd--radio"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_RadioGroup, {
              modelValue: _ctx.formValue.Capacity,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formValue.Capacity) = $event)),
              onChange: _ctx.clearChild
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.capacityEnum, (item) => {
                  return (_openBlock(), _createBlock(_component_Radio, {
                    label: item.key,
                    key: item.key
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.value), 1)
                    ]),
                    _: 2
                  }, 1032, ["label"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "onChange"])
          ]),
          _: 1
        }),
        (_ctx.formValue.Capacity === 3)
          ? (_openBlock(), _createBlock(_component_OtherInfo, {
              key: 0,
              ref: "childForm",
              childInfo: _ctx.childInfo
            }, null, 8, ["childInfo"]))
          : _createCommentVNode("", true),
        (_ctx.formValue.Capacity === 1)
          ? (_openBlock(), _createBlock(_component_StudentInfo, {
              key: 1,
              ref: "childForm",
              childInfo: _ctx.childInfo
            }, null, 8, ["childInfo"]))
          : _createCommentVNode("", true),
        (_ctx.formValue.Capacity === 2)
          ? (_openBlock(), _createBlock(_component_JobInfo, {
              key: 2,
              ref: "childForm",
              childInfo: _ctx.childInfo
            }, null, 8, ["childInfo"]))
          : _createCommentVNode("", true),
        _createVNode(_component_FormItem, {
          label: "",
          prop: "Agreement",
          "label-width": "0",
          class: "el-form-item-odd"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Popover, {
              placement: "top-start",
              trigger: "hover",
              content: "请先完成文档阅读后再勾选同意"
            }, {
              reference: _withCtx(() => [
                _createVNode(_component_Checkbox, {
                  modelValue: _ctx.formValue.Agreement,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formValue.Agreement) = $event)),
                  class: "margin-r-10",
                  disabled: _ctx.hasShowAgreementDialog || _ctx.hasShowRuleDialog
                }, null, 8, ["modelValue", "disabled"]),
                _hoisted_2
              ]),
              _: 1
            }),
            _createElementVNode("div", {
              class: "submit-apply-bd--link",
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.showAgreement && _ctx.showAgreement(...args)))
            }, "《参赛协议》"),
            _createElementVNode("div", {
              class: "submit-apply-bd--link",
              onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.showRule && _ctx.showRule(...args)))
            }, "《大赛规程》")
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model", "rules"]),
    (_ctx.userStatus?.AuditState !== 3)
      ? (_openBlock(), _createBlock(_component_Button, {
          key: 0,
          onClick: _ctx.saveUser,
          loading: _ctx.saveLoading,
          class: "submit-apply-bd--btn"
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["onClick", "loading"]))
      : _createCommentVNode("", true),
    _createVNode(_component_LoginDialog, {
      dialogShow: _ctx.showLoginDialog,
      showClose: true,
      onClose: _ctx.closeToIndex
    }, null, 8, ["dialogShow", "onClose"]),
    _createVNode(_component_Dialog, {
      title: "参赛协议",
      modelValue: _ctx.showAgreementDialog,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.showAgreementDialog) = $event)),
      width: "80%",
      center: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_RaceAgreement)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_Dialog, {
      title: "大赛规程",
      modelValue: _ctx.showRuleDialog,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.showRuleDialog) = $event)),
      width: "80%",
      center: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_RaceRule)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}